module.exports = __webpack_public_path__ + "static/media/drop_down_not_show_narrow.21a1179b.svg";